/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './Renegociacao25EmpCanais.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function Renegociacao25EmpCanais() {
  const [showMsg, setShowMsg] = useState(false);
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="renegociacao25-emp-canais">
        <ContainerHome24>
          <div className="canais-principal">
            <div className="canais-textos">
              <h2 className="canais-titulo">Canais oficiais</h2>
              <p className="canais-texto">Veja abaixo os canais para falar sobre a negociação</p>
            </div>
            <div className="canais-carrossel">
              <CustomEmblaCarouselHome24
                // loop
                enableBullets
                detectBulletCount
                // hideOverflow
                enableMobileArrows
                enablePrevArrow
                //autoplay={100000}
              >
                {({ className }) => (
                  <>
                    <div className={`slide ${className}`}>
                      <a
                        href="https://wa.me/message/LGUGWVSCZFERO1"
                        target="_blank"
                        className="slide-contain"
                      >
                        <div className="canais-card-img-titulo">
                          <img src="assets/renegociacao25/canais/ic-whatsapp.svg" alt="" />
                          <p className="canais-card-titulo">Whatsapp</p>
                        </div>
                        <p className="canais-card-link">Acessar</p>
                        {typeof window === 'undefined' ? (
                          <></>
                        ) : (
                          <>
                            {width >= 992 && (
                              <img
                                src="assets/renegociacao25-emp/qrcode-whatsapp-santander.jpg"
                                alt="qrcode whatsapp"
                                className="qrcode-whatsapp"
                              />
                            )}
                          </>
                        )}
                      </a>
                    </div>
                    <div className={`slide ${className}`}>
                      <a
                        href="tel:08007204362"
                        id="tel-0800-720-4362"
                        target="_blank"
                        rel="noopener"
                        className="slide-contain"
                      >
                        <div className="canais-card-img-titulo">
                          <img src="assets/renegociacao25/canais/ic-central.svg" alt="" />
                          <p className="canais-card-titulo">Central de Atendimento</p>
                        </div>
                        <p className="canais-card-link">0800 720 4362</p>
                      </a>
                    </div>
                  </>
                )}
              </CustomEmblaCarouselHome24>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default Renegociacao25EmpCanais;
